/**
 * Mobile Menu
 * @dependencies jQuery
 */

import $ from 'jquery'

const $triggerMenu = $('.js-menu-toggle')

if ($triggerMenu.length) {
  // We dont need fast load, so we can keep the slow `load` event lifecycle
  window.addEventListener('load', () => {
    // ### DrillDown Menu
    // Settings
    // ### Toggle Open/Close
    $triggerMenu.on('click', (ev) => {
      ev.preventDefault()
      $('body').toggleClass('nav-open')
    })
  })
}

// Debounce the event to avoid too many triggers
function debounce(func, timeout = 250) {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, timeout)
  }
}
